import FAQ from './FAQ.jsx';

export {
  FAQ
}


// WEBPACK FOOTER //
// ./components/faq/index.js